"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoIconWithTooltip = void 0;
var Info_1 = require("@mui/icons-material/Info");
var React = require("react");
var IconWithTooltip_1 = require("./IconWithTooltip");
var style = {
    color: '#0040ff',
    display: 'inline-block',
};
var InfoIconWithTooltip = function (_a) {
    var placement = _a.placement, text = _a.text;
    return (React.createElement("div", { style: style },
        React.createElement(IconWithTooltip_1.default, { Icon: Info_1.default, text: text, placement: placement })));
};
exports.InfoIconWithTooltip = InfoIconWithTooltip;
//# sourceMappingURL=InfoIconWithTooltip.js.map